import { Box, Grid, Typography } from '@material-ui/core';

import { InfoTooltipWrapper } from '@/components/modules/Application/components/_shared/components/InfoTooltipWrapper';
import { useTableLayoutStyle } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useTableLayoutStyle';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

export const CartHeader = () => {
  const { sm } = useScreen();
  const { getItemSizes, tableSpacing, actionsWidth } = useTableLayoutStyle();

  return (
    <Box display={'flex'} flexDirection={'row'}>
      <Grid
        container
        style={{ position: 'relative', zIndex: 1, marginBottom: '-10px', flexGrow: 1 }}
        spacing={tableSpacing}
      >
        <Grid item xs={getItemSizes(0)}>
          <Typography variant={'caption'} color={'textPrimary'} style={{ textAlign: sm ? 'center' : 'left' }}>
            <Text tId={'UNITS_SHORT'} />
          </Typography>
        </Grid>
        <Grid item xs={getItemSizes(1)}>
          <Typography variant={'caption'} color={'textPrimary'}>
            <Text tId={'DESCRIPTION'} />
          </Typography>
        </Grid>
        <Grid item xs={getItemSizes(2)}>
          <InfoTooltipWrapper textId={'UNIT_PRICE_WITH_TAX'} justifyContent={'flex-end'}>
            <Font variant={'caption'} color={'textPrimary'}>
              <Text tId={'UNIT_PRICE'} />
            </Font>
          </InfoTooltipWrapper>
        </Grid>
        <Grid item xs={getItemSizes(3)}>
          <InfoTooltipWrapper textId={'TOTAL_PRICE_WITH_TAX'} justifyContent={'flex-end'}>
            <Font variant={'caption'} color={'textPrimary'}>
              <Text tId={'TOTAL_PRICE'} />
            </Font>
          </InfoTooltipWrapper>
        </Grid>
      </Grid>
      <Box width={actionsWidth} />
    </Box>
  );
};
